import React, { PropsWithChildren } from 'react'

import {
  Box,
  Button,
  ButtonColorVariant,
  ButtonSize,
  ButtonVariant,
  Display,
  DisplayPosition,
  FlexDirection,
  Overflow,
} from '@gousto-internal/citrus-react'

import { useCarouselNav } from './useCarouselNav'

export const Carousel = ({ children }: PropsWithChildren<React.ReactNode>) => {
  const { emblaRef, prevBtnDisabled, nextBtnDisabled, onPrevButtonClick, onNextButtonClick } =
    useCarouselNav()

  const isNextButnHidden = nextBtnDisabled ? 'none' : 'flex'
  const isPrevButnHidden = prevBtnDisabled ? 'none' : 'flex'

  return (
    <Box
      data-testid="carousel"
      display={Display.Flex}
      flexDirection={FlexDirection.Column}
      position={DisplayPosition.Relative}
    >
      <Box className="embla__viewport" ref={emblaRef} width="100%" overflowX={Overflow.Hidden}>
        <Box className="embla__container" display={Display.Flex} width="100%" gap={8}>
          {children}
        </Box>
        <Button
          aria-label="Previous slide"
          disabled={prevBtnDisabled}
          className="embla__prev"
          colorVariant={ButtonColorVariant.Secondary}
          icon="arrow_back"
          onClick={onPrevButtonClick}
          size={ButtonSize.Large}
          style={{
            borderRadius: '50%',
            display: isPrevButnHidden,
            position: 'absolute',
            bottom: '46%',
            left: '3%',
          }}
          variant={ButtonVariant.Icon}
        />
        <Button
          aria-label="Next slide"
          disabled={nextBtnDisabled}
          className="embla__next"
          colorVariant={ButtonColorVariant.Secondary}
          icon="arrow_right"
          onClick={onNextButtonClick}
          size={ButtonSize.Large}
          style={{
            borderRadius: '50%',
            display: isNextButnHidden,
            position: 'absolute',
            bottom: '46%',
            right: '3%',
          }}
          variant={ButtonVariant.Icon}
        />
      </Box>
    </Box>
  )
}
